import { createClient } from "@supabase/supabase-js";

/**
 * Paylaşılan "hub" Supabase projesi — auth.users TahminLigi ve TradingAgents
 * ile ORTAK. FootballAgents girişi aynı kimliktir; kullanıcı bir kez üye olur.
 *
 * URL + publishable (anon) key public-safe — frontend'de bulunması normal.
 * Gizli hiçbir şey yok (JWT doğrulama backend'de JWKS ile yapılır).
 */
export const supabase = createClient(
  "https://ogazwtcgygvaafcdgkwe.supabase.co",
  "sb_publishable_0KGZVH-Kaq85oTXPqgWX6g_1bRGsTUD",
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } }
);
